import { createAsyncThunk } from "@reduxjs/toolkit";
import { getObjects } from "domain/objects/api/get-objects";
import { ObjectsRequestDto } from "domain/objects/entities/dtos/objects-request.dto";

const getObjectsAction = createAsyncThunk(
  "objects/v2/getObjects",
  async (payload: ObjectsRequestDto) => {
    return await getObjects(payload);
  }
);

export default getObjectsAction;
